import type { PlayerPoolMember } from '~/domains/contest/domains/services/interfaces/player-pool-member.interface';
import { getAbbreviatedTierDisplayLabel } from '~/domains/contest/domains/common/utils/playerCardDisplay';

import type { PlayerInfo } from '../../types/player';

import { parseInjuryTag } from './utils';

const parseBasePlayerInfoTeamSport = (pick: PlayerPoolMember): Partial<PlayerInfo> => {
  const playerLineup = pick.game?.[
    pick.team.id === pick.game?.home.id ? 'home' : 'away'
  ].lineup?.find((lineup) => lineup?.id === pick?.entity_id);

  return {
    tag: {
      position: pick.attributes?.primary_position as string,
      // We need new type for attributes in pick type
      // salary?: number;
      injury: parseInjuryTag(pick),
      playerTier: pick.tierId ? getAbbreviatedTierDisplayLabel(pick.tierId) : undefined,
      lineup: playerLineup,
    },
  };
};

export default parseBasePlayerInfoTeamSport;
